import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

const DEFAULT_DENIED_MESSAGE = 'Default message!';

export default Factory.extend({
  name: () => faker.lorem.word(),
  description: () => faker.lorem.sentence(),

  type: 'Flows::Global',

  withSignInFieldPage: trait({
    afterCreate(flow, server) {
      flow.signInFieldPage = server.create(
        'sign-in-field-page',
        'withEmailAddressSignInField',
        'withFullNameSignInField',
        'withSingleSelectionSignInField',
        { flow }
      );
    },
  }),

  withQuestions: trait({
    afterCreate(flow, server) {
      flow.signInFieldPage = server.create('sign-in-field-page', 'withQuestions', { flow });
    },
  }),

  withSummaryPage: trait({
    afterCreate(flow, server) {
      flow.summaryPage = server.create('summary-page', {
        flow,
        message: DEFAULT_DENIED_MESSAGE,
        defaultMessage: DEFAULT_DENIED_MESSAGE,
        kind: 'none',
      });
    },
  }),

  withAgreementPage: trait({
    afterCreate(flow, server) {
      flow.agreementPage = server.create('agreement-page', {
        flow,
      });
    },
  }),
});
